module.exports = __webpack_public_path__ + "img/c01_unitgastraphetes_Normal_ua.d7bee421.webp";